module.exports = __webpack_public_path__ + "static/media/module-beheer.b3097be6.svg";